import { createContext } from "react";

export const StudyContext = createContext();

